var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    [
      _c(
        "cms-heading",
        { attrs: { title: "Projecten", icon: "entypo-archive" } },
        [
          _vm.userIsAdmin
            ? _c(
                "cms-button",
                {
                  attrs: {
                    color: "positive",
                    icon: "magicon-plus",
                    route: "project-add",
                  },
                },
                [_vm._v("Toevoegen")]
              )
            : _vm._e(),
          _c("cms-searchbar", {
            model: {
              value: _vm.searchQuery,
              callback: function ($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery",
            },
          }),
        ],
        1
      ),
      _c(
        "cms-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            "item-count": _vm.projects.totalCount || 0,
            "items-per-page": _vm.itemsPerPage,
            placeholder: !_vm.projects.items || !_vm.projects.items.length,
            clickable: "true",
          },
          on: {
            page: function ($event) {
              _vm.offset = arguments[0]
            },
          },
        },
        [
          _c(
            "cms-table-header",
            [
              _c(
                "cms-th",
                {
                  attrs: { field: "title" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Titel")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "code" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Projectcode")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "locationTitle" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Locatie")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "startDate" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Startdatum")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "endDate" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Einddatum")]
              ),
              _c("cms-th"),
            ],
            1
          ),
          _vm._l(_vm.projects.items, function (project) {
            return _c(
              "tr",
              {
                on: {
                  click: function ($event) {
                    return _vm.showLoggers(project)
                  },
                },
              },
              [
                _c("td", [_vm._v(_vm._s(project.title))]),
                _c("td", [_vm._v(_vm._s(project.code))]),
                _c("td", [
                  _vm._v(
                    _vm._s(project.locationManual || project.locationTitle)
                  ),
                ]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(project.startDate, "LL"))),
                ]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(project.endDate, "LL"))),
                ]),
                _c(
                  "td",
                  {
                    staticClass: "actions",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("cms-link", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Loggers bekijken",
                          expression: "'Loggers bekijken'",
                        },
                      ],
                      attrs: {
                        icon: "entypo-eye",
                        to: {
                          name: "loggers-project",
                          params: { projectCode: project.code },
                        },
                      },
                    }),
                    _vm.userIsAdmin
                      ? _c("cms-link", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Wijzigen",
                              expression: "'Wijzigen'",
                            },
                          ],
                          attrs: {
                            icon: "magicon-edit",
                            to: {
                              name: "project-edit",
                              params: { id: project.id },
                            },
                          },
                        })
                      : _vm._e(),
                    _vm.userIsAdmin
                      ? _c("cms-link", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Verwijderen",
                              expression: "'Verwijderen'",
                            },
                          ],
                          attrs: { icon: "magicon-trash" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteProject(project)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }